<label class="label">
  <span class="flex items-baseline gap-1">
    <svg-icon *ngIf="icon" [name]="icon" [size]="13"></svg-icon>
    <span *ngIf="isRequired" class="text-red-600">*</span>
    <span class="truncate">{{ text }}</span>
  </span>
</label>
